import { Injectable, Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '@nx-vigil/core/web/auth/feature';
import { EnvironmentStore } from '@nx-vigil/core/web/environment/data-access';
import { Attributes } from '@opentelemetry/api';

@Injectable()
export class OTELAttributesService {
  public readonly attributes: Signal<Attributes>;

  public constructor() {
    const environment = inject(EnvironmentStore);
    const auth = inject(AuthService);

    const version = toSignal(environment.version$);
    const user = toSignal(auth.user$);

    this.attributes = computed(() => ({
      'app.version': version() ?? '<unknown>',
      'user.email': user()?.email ?? '<not-logged-in>',
    }));
  }
}
